import {
  usePreviousMouseDownRef
} from "./7JNF6I52.js";
import {
  useDisclosureContent
} from "./6AJCHLAV.js";
import {
  useBooleanEvent,
  useEvent,
  useForkRef,
  useSafeLayoutEffect
} from "./ASYR66PQ.js";
import {
  __spreadProps,
  __spreadValues
} from "./4BKCJXBM.js";

// src/dialog/dialog-backdrop.tsx
import { useMemo, useRef } from "react";
import { isSelfTarget } from "@ariakit/core/utils/events";
import { noop } from "@ariakit/core/utils/misc";
import { jsx } from "react/jsx-runtime";
function DialogBackdrop({
  store,
  backdrop,
  backdropProps,
  hideOnInteractOutside = true,
  hideOnEscape = true,
  hidden,
  children
}) {
  const ref = useRef(null);
  store = useMemo(
    () => __spreadProps(__spreadValues({}, store), {
      // Override the setContentElement method to prevent the backdrop from
      // overwriting the dialog's content element. TODO: Refactor this.
      setContentElement: noop
    }),
    [store]
  );
  const contentElement = store.useState("contentElement");
  useSafeLayoutEffect(() => {
    const backdrop2 = ref.current;
    const dialog = contentElement;
    if (!backdrop2)
      return;
    if (!dialog)
      return;
    backdrop2.style.zIndex = getComputedStyle(dialog).zIndex;
  }, [contentElement]);
  const onClickProp = backdropProps == null ? void 0 : backdropProps.onClick;
  const hideOnInteractOutsideProp = useBooleanEvent(hideOnInteractOutside);
  const mounted = store.useState("mounted");
  const previousMouseDownRef = usePreviousMouseDownRef(mounted);
  const onClick = useEvent((event) => {
    onClickProp == null ? void 0 : onClickProp(event);
    if (event.defaultPrevented)
      return;
    if (!isSelfTarget(event))
      return;
    if (previousMouseDownRef.current !== event.currentTarget)
      return;
    if (!hideOnInteractOutsideProp(event))
      return;
    event.stopPropagation();
    store.hide();
  });
  const onKeyDownProp = backdropProps == null ? void 0 : backdropProps.onKeyDown;
  const hideOnEscapeProp = useBooleanEvent(hideOnEscape);
  const onKeyDown = useEvent((event) => {
    onKeyDownProp == null ? void 0 : onKeyDownProp(event);
    if (event.defaultPrevented)
      return;
    if (event.key !== "Escape")
      return;
    if (!isSelfTarget(event))
      return;
    if (!hideOnEscapeProp(event))
      return;
    store.hide();
  });
  const props = useDisclosureContent(__spreadProps(__spreadValues({
    store,
    id: void 0,
    role: "presentation",
    tabIndex: -1,
    hidden
  }, backdropProps), {
    ref: useForkRef(backdropProps == null ? void 0 : backdropProps.ref, ref),
    onClick,
    onKeyDown,
    style: __spreadValues({
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }, backdropProps == null ? void 0 : backdropProps.style)
  }));
  const Component = typeof backdrop !== "boolean" ? backdrop || "div" : "div";
  return /* @__PURE__ */ jsx(Component, __spreadProps(__spreadValues({}, props), { "data-backdrop": contentElement == null ? void 0 : contentElement.id, children }));
}

export {
  DialogBackdrop
};
